export default function travelExpense(
    vehicleType: string,
    cv: number,
    distance: number,
    isElectric: boolean,
): any {
    let coef = 0;
    let fixAmount = 0;

    if (vehicleType === "CAR") {
        // ** THERMIC CAR -> Voiture pas éléctrique
        if (!isElectric) {
            if (distance <= 5000) {
                if (cv <= 3) {
                    coef = 0.529;
                } else if (cv === 4) {
                    coef = 0.606;
                } else if (cv === 5) {
                    coef = 0.636;
                } else if (cv === 6) {
                    coef = 0.665;
                } else {
                    coef = 0.697;
                }
            } else if (distance <= 20000) {
                if (cv <= 3) {
                    coef = 0.316;
                    fixAmount = 1065;
                } else if (cv === 4) {
                    coef = 0.34;
                    fixAmount = 1330;
                } else if (cv === 5) {
                    coef = 0.357;
                    fixAmount = 1395;
                } else if (cv === 6) {
                    coef = 0.374;
                    fixAmount = 1457;
                } else {
                    coef = 0.394;
                    fixAmount = 1515;
                }
            } else {
                if (cv <= 3) {
                    coef = 0.37;
                } else if (cv === 4) {
                    coef = 0.407;
                } else if (cv === 5) {
                    coef = 0.427;
                } else if (cv === 6) {
                    coef = 0.447;
                } else {
                    coef = 0.47;
                }
            }
        }
    } else if (vehicleType === "TWO_REAR_WHEELS_GT_50") {
        // "TWO_REAR_WHEELS_GT_50" -> Moto > 50cm3 / Motocyclettes
        if (distance <= 3000) {
            if (cv === 1 || cv === 2) {
                coef = 0.395;
            } else if (cv === 3 || cv === 4 || cv === 5) {
                coef = 0.468;
            } else {
                coef = 0.606;
            }
        } else if (distance <= 6000) {
            if (cv === 1 || cv === 2) {
                coef = 0.099;
                fixAmount = 891;
            } else if (cv === 3 || cv === 4 || cv === 5) {
                coef = 0.082;
                fixAmount = 1158;
            } else {
                coef = 0.079;
                fixAmount = 1583;
            }
        } else {
            if (cv === 1 || cv === 2) {
                coef = 0.248;
            } else if (cv === 3 || cv === 4 || cv === 5) {
                coef = 0.275;
            } else {
                coef = 0.343;
            }
        }
    } else if (vehicleType === "TWO_REAR_WHEELS_LTE_50") {
        // "TWO_REAR_WHEELS_LTE_50" -> Moto <= 50cm3 / Cyclomoteurs
        if (distance <= 3000) {
            coef = 0.315;
        } else if (distance <= 6000) {
            coef = 0.079;
            fixAmount = 711;
        } else {
            coef = 0.198;
        }
    } else if (vehicleType === "BICYCLE") {
        // "BICYCLE" -> Vélo
        coef = 0.29;
    }

    let travelExpense = distance * coef + fixAmount;

    if (isElectric && vehicleType !== "BICYCLE") {
        travelExpense = travelExpense * 1.2;
    }

    return {
        travelExpenseAmount: travelExpense,
        coef: coef,
        fixAmount: fixAmount,
    };
}
